/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ProgramsRouteImport } from './routes/programs'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminRegistrationsRouteImport } from './routes/admin.registrations'
import { Route as AdminGalleryRouteImport } from './routes/admin.gallery'
import { Route as ApiPublicNotifyRegistrationRouteImport } from './routes/api.public.notify-registration'

const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
  id: '/sitemap.xml',
  path: '/sitemap.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsRoute = ProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessibilityRoute = AccessibilityRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRegistrationsRoute = AdminRegistrationsRouteImport.update({
  id: '/registrations',
  path: '/registrations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGalleryRoute = AdminGalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => AdminRoute,
} as any)
const ApiPublicNotifyRegistrationRoute =
  ApiPublicNotifyRegistrationRouteImport.update({
    id: '/api/public/notify-registration',
    path: '/api/public/notify-registration',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/accessibility': typeof AccessibilityRoute
  '/privacy': typeof PrivacyRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/programs': typeof ProgramsRoute
  '/register': typeof RegisterRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/support': typeof SupportRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/': typeof AdminIndexRoute
  '/api/public/notify-registration': typeof ApiPublicNotifyRegistrationRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/accessibility': typeof AccessibilityRoute
  '/gallery': typeof GalleryRoute
  '/privacy': typeof PrivacyRoute
  '/login': typeof LoginRoute
  '/programs': typeof ProgramsRoute
  '/register': typeof RegisterRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/support': typeof SupportRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin': typeof AdminIndexRoute
  '/api/public/notify-registration': typeof ApiPublicNotifyRegistrationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/accessibility': typeof AccessibilityRoute
  '/gallery': typeof GalleryRoute
  '/privacy': typeof PrivacyRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/programs': typeof ProgramsRoute
  '/register': typeof RegisterRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/support': typeof SupportRoute
  '/admin/registrations': typeof AdminRegistrationsRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/': typeof AdminIndexRoute
  '/api/public/notify-registration': typeof ApiPublicNotifyRegistrationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/accessibility'
    | '/gallery'
    | '/privacy'
    | '/admin'
    | '/login'
    | '/programs'
    | '/register'
    | '/sitemap.xml'
    | '/support'
    | '/admin/registrations'
    | '/admin/gallery'
    | '/admin/settings'
    | '/admin/'
    | '/api/public/notify-registration'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/accessibility'
    | '/gallery'
    | '/login'
    | '/programs'
    | '/register'
    | '/sitemap.xml'
    | '/support'
    | '/privacy'
    | '/admin/registrations'
    | '/admin/gallery'
    | '/admin/settings'
    | '/admin'
    | '/api/public/notify-registration'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/accessibility'
    | '/gallery'
    | '/admin'
    | '/login'
    | '/programs'
    | '/register'
    | '/sitemap.xml'
    | '/support'
    | '/privacy'
    | '/admin/registrations'
    | '/admin/gallery'
    | '/admin/settings'
    | '/admin/'
    | '/api/public/notify-registration'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccessibilityRoute: typeof AccessibilityRoute
  GalleryRoute: typeof GalleryRoute
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
  ProgramsRoute: typeof ProgramsRoute
  RegisterRoute: typeof RegisterRoute
  SitemapDotxmlRoute: typeof SitemapDotxmlRoute
  SupportRoute: typeof SupportRoute
  PrivacyRoute: typeof PrivacyRoute
  ApiPublicNotifyRegistrationRoute: typeof ApiPublicNotifyRegistrationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap.xml': {
      id: '/sitemap.xml'
      path: '/sitemap.xml'
      fullPath: '/sitemap.xml'
      preLoaderRoute: typeof SitemapDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs': {
      id: '/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof ProgramsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility': {
      id: '/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof AccessibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/registrations': {
      id: '/admin/registrations'
      path: '/registrations'
      fullPath: '/admin/registrations'
      preLoaderRoute: typeof AdminRegistrationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/gallery': {
      id: '/admin/gallery'
      path: '/gallery'
      fullPath: '/admin/gallery'
      preLoaderRoute: typeof AdminGalleryRouteImport
      parentRoute: typeof AdminRoute
    }
    '/api/public/notify-registration': {
      id: '/api/public/notify-registration'
      path: '/api/public/notify-registration'
      fullPath: '/api/public/notify-registration'
      preLoaderRoute: typeof ApiPublicNotifyRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteChildren {
  AdminRegistrationsRoute: typeof AdminRegistrationsRoute
  AdminGalleryRoute: typeof AdminGalleryRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminRegistrationsRoute: AdminRegistrationsRoute,
  AdminGalleryRoute: AdminGalleryRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccessibilityRoute: AccessibilityRoute,
  GalleryRoute: GalleryRoute,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
  ProgramsRoute: ProgramsRoute,
  RegisterRoute: RegisterRoute,
  SitemapDotxmlRoute: SitemapDotxmlRoute,
  SupportRoute: SupportRoute,
  PrivacyRoute: PrivacyRoute,
  ApiPublicNotifyRegistrationRoute: ApiPublicNotifyRegistrationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
